/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

const WyAnalyticsConfigurationUtils = {
  checkNested(obj) {
    var args = Array.prototype.slice.call(arguments, 1);
    for (var i = 0; i < args.length; i++) {
      if (!obj || !obj.hasOwnProperty(args[i].key)) {
        if(args[i].type == 'Object') obj[args[i].key] = {};
        if(args[i].type == 'Array') obj[args[i].key] = [];
      }
      obj = obj[args[i].key];
    }
    return obj;
  },
  getOverviewTargetMockData() {
    //Overview Target Data
    return [
      {
        key: 'understandingTotal',
        target: {
          value: 90,
          reverse: false
        }
      },
      {
        key: 'containmentTotal',
        target: {
          value: 25,
          reverse: false
        }
      },
      {
        key: 'negativeFeedbackScoreTotal',
        target: {
          value: 90,
          reverse: true
        }
      }
    ]
  },
  getResponsePerformanceTargetMockData() {
    return [
      {
        key: 'negativeFeedbackRate',
        target: {
          value: 90,
          reverse: true
        }
      },
      {
        key: 'handoffRate',
        target: {
          value: 25,
          reverse: false
        }
      },
      {
        key: 'botRepetitionRate',
        target: {
          value: 90,
          reverse: false
        }
      }
    ]
  },
  getNluIntentPerformanceTargetMockData() {
    return [
      {
        key: 'nlu',
        target: {
          value: 90,
          reverse: false
        }
      },
      {
        key: 'falsePositives',
        target: {
        value: 25,
        reverse: true
        }
      },
      {
        key: 'messagesNotUnderstood',
        target: {
          value: 90,
          reverse: false
        }
      },
      {
        key: 'lowQualityIntents',
        target: {
          value: 85,
          reverse: false
        }
      }
    ]
  },

  //Performance Comparison Target Data
  getComparisonTargetMockData() {
    return [
      {
        key: 'numOfConversations',
        total: {
          value: 5000,
          operator: '>',
          suffix: '',
          enabled: true
        },
        lang: {
          value: 5000,
          operator: '>',
          suffix: '',
          enabled: true
        },
        channel: {
          value: 5000,
          operator: '>',
          suffix: '',
          enabled: true
        },
        yearly: {
          value: 5000,
          operator: '>',
          suffix: '',
          enabled: true
        },
        quarterly: {
          value: 5000,
          operator: '>',
          suffix: '',
          enabled: true
        },
        monthly: {
          value: 5000,
          operator: '>',
          suffix: '',
          enabled: true
        },
        daily: {
          value: 5000,
          operator: '>',
          suffix: '',
          enabled: true
        }
      },
      {
        key: 'conversationsContained',
        total: {
          value: null,
          operator: '-',
          suffix: '',
          enabled: false
        },
        lang: {
          value: null,
          operator: '-',
          suffix: '',
          enabled: false
        },
        channel: {
          value: null,
          operator: '-',
          suffix: '',
          enabled: false
        },
        yearly: {
          value: null,
          operator: '-',
          suffix: '',
          enabled: false
        },
        quarterly: {
          value: null,
          operator: '-',
          suffix: '',
          enabled: false
        },
        monthly: {
          value: null,
          operator: '-',
          suffix: '',
          enabled: false
        },
        daily: {
          value: null,
          operator: '-',
          suffix: '',
          enabled: false
        }
      },
      {
        key: 'underTrainedIntents',
        total: {
          value: 5,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        lang: {
          value: 5,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        channel: {
          value: 5,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        yearly: {
          value: 5,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        quarterly: {
          value: 5,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        monthly: {
          value: 5,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        daily: {
          value: 5,
          operator: '<',
          suffix: '%',
          enabled: true
        }
      },
      {
        key: 'duplicateIntents',
        total: {
          value: 0,
          operator: '=',
          suffix: '%',
          enabled: true
        },
        lang: {
          value: 0,
          operator: '=',
          suffix: '%',
          enabled: true
        },
        channel: {
          value: 0,
          operator: '=',
          suffix: '%',
          enabled: true
        },
        yearly: {
          value: 0,
          operator: '=',
          suffix: '%',
          enabled: true
        },
        quarterly: {
          value: 0,
          operator: '=',
          suffix: '%',
          enabled: true
        },
        monthly: {
          value: 0,
          operator: '=',
          suffix: '%',
          enabled: true
        },
        daily: {
          value: 0,
          operator: '=',
          suffix: '%',
          enabled: true
        }
      },
      {
        key: 'numInconsistentIntents',
        total: {
          value: 6,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        lang: {
          value: 6,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        channel: {
          value: 6,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        yearly: {
          value: 6,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        quarterly: {
          value: 6,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        monthly: {
          value: 6,
          operator: '<',
          suffix: '%',
          enabled: true
        },
        daily: {
          value: 6,
          operator: '<',
          suffix: '%',
          enabled: true
        }
      }
    ]
  }
}

export default WyAnalyticsConfigurationUtils;